import * as React from "react";
import excellentBadge from "../../../../assets/images/badge_excellent.svg";
import needGuidanceBadge from "../../../../assets/images/badge_need_guidance.svg";
import lowSpeedBadge from "../../../../assets/images/badge_low_speed.svg";
import lowAccuracyBadge from "../../../../assets/images/badge_low_accuracy.svg";
import incompleteBadge from "../../../../assets/images/badge_incomplete.svg";
import highAccuracyBadge from "../../../../assets/images/badge_high_accuracy.svg";
import highAchievementBadge from "../../../../assets/images/badge_high_achievement.svg";
import guessingSuspectedBadge from "../../../../assets/images/badge_guessing_suspected.svg";
import completeFirstBadge from "../../../../assets/images/badge_round_1.svg";
import completeSecondBadge from "../../../../assets/images/badge_round_2.svg";
import completeAllBadge from "../../../../assets/images/badge_round_3.svg";
import improveBadge from "../../../../assets/images/badge_up.svg"
import declineBadge from "../../../../assets/images/badge_down.svg"

const badgeStyles = {
    "EXCELLENT_LEARNING": {
        image: excellentBadge
    },
    "NEEDS_GUIDANCE": {
        image: needGuidanceBadge
    },
    "INCOMPLETE": {
        image: incompleteBadge
    },
    "COMPLETE_ALL": {
        image: completeAllBadge
    },
    "HIGH_ACHIEVEMENT": {
        image: highAchievementBadge
    },
    "HIGH_ACCURACY": {
        image: highAccuracyBadge
    },
    "LOW_ACCURACY": {
        image: lowAccuracyBadge
    },
    "LOW_SPEED": {
        image: lowSpeedBadge
    },
    "GUESSING_SUSPECTED": {
        image: guessingSuspectedBadge
    },
    "COMPLETE_FIRST": {
        image: completeFirstBadge
    },
    "COMPLETE_SECOND": {
        image: completeSecondBadge
    },
    "GRADE_IMPROVED": {
        image: improveBadge
    },
    "GRADE_DECLINED": {
        image: declineBadge
    }
};

const Badge = ({ text }) => {
    if(text==="VIEW_ALL"){
        return null;
    }
    const style = badgeStyles[text] || {
        color: "text-gray-500",
        border: "border-gray-500",
        icon: "/images/default-icon.png"
    };
    return (
            <img
                loading="lazy"
                src={`${style.image}`}
                className="w-[103px]"
                alt="badge"
            />
    );
}

export default Badge;